import type { Operator } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleOperatorQueryResult {
  operator: Operator
}

export interface SingleOperatorQueryVariables {
  id?: GQL_ID
}

const GQL_QUERY_SINGLE_OPERATOR = gql`
  query (
    $id: ID!
  ) {
    operator: singleOperator(
      id: $id
    ) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      email
    }
  }
`

export const useFetchSingleOperator = (
  variables: SingleOperatorQueryVariables
) =>
  useQuery<SingleOperatorQueryResult, SingleOperatorQueryVariables>(
    GQL_QUERY_SINGLE_OPERATOR,
    { variables, skip: !variables.id }
  )
